// 上新精选
export default {
  routes: [
    {
      path: '/new-selection',
      name: 'new-selection',
      meta: {
        title: '上新精选',
        pageId: 'S5373'
      },
      component: () => import(/* webpackChunkName: "publishH5" */ '../views/newSelection/index.vue')
    }
  ]
}
